import React from 'react';

export interface IconChefProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconChef: React.FC<IconChefProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M17.059 4.96181C16.5553 4.96181 16.082 5.07952 15.6683 5.28747C15.2698 3.96835 13.5521 3 12.0118 3C10.4715 3 8.7319 3.96835 8.33253 5.28747C7.91886 5.07952 7.44551 4.96181 6.94356 4.96181C5.3175 4.96181 4 6.19147 4 7.70834C4 9.22522 5.26033 10.4549 6.94188 10.4549V21H17.0312V10.4549C18.7128 10.4549 20 9.22522 20 7.70834C20 6.19147 18.6833 4.96181 17.059 4.96181Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" /> <path d="M6.94141 17.8611H17.0307" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" />  
    </svg>
  );
};

export default IconChef;
